import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import clsx from 'clsx';

import BobRadioGroup from '../../../../components/BobRadioGroup';
import BobNumericInputField from '../../../../components/BobNumericInputField';
import BobSelectField from '../../../../components/BobSelectField';
import BobInputField from '../../../../components/BobInputField';

const EquipmentEnergyMonitorPanel = ({
    activeSensors,
    availableSensors,
    classes,
    equipmentAttributes,
    energyValue,
    formik,
    handleBlurValue,
    handleChangeValue,
    hasValidated,
    sensorAttributes,
    sensorIndex,
    setEnergyValue,
    setSensors,
    ...props
}) => {
    const [options, setOptions] = useState([]);
    const [statusSensors, setStatusSensors] = useState([]);
    const [energySensors, setEnergySensors] = useState([]);

    useEffect(() => {
        if (!isEmpty(sensorAttributes)) {
            const attribute = sensorAttributes.find(item => item.name === 'energyUnit');
            if (attribute) {
                let values = [...attribute.avpLookupValues];
                let formattedOptions = [];
                values.forEach(x => {
                    formattedOptions.push({ id: x.id, name: x.value });
                });
                setOptions(formattedOptions);
            }
        }
    }, [sensorAttributes]);

    useEffect(() => {
        let status = [];
        let energy = [];

        if (availableSensors) {
            let filter = ['status', 'command'];

            availableSensors.forEach(item => {
                if (item.displayDataType === 'boolean' && filter.some(x => item.sensorType.name.toLowerCase().includes(x))) {
                    status.push(item);
                } else if (item.displayDataType !== 'boolean') {
                    energy.push(item);
                }
            });
            setStatusSensors(status);
            setEnergySensors(energy);
        }
    }, [availableSensors]);

    const energyValues = [{ label: 'Status Value (On/Off, True/False, etc.)', value: 'statusValue' }, { label: 'Energy Value (Watts, Amps, kWh, etc.)', value: 'energyValue' }];
    const phaseValues = [{ label: 'Single Phase', value: 'singlePhase' }, { label: 'Three Phase', value: 'threePhase' }];

    const handleChange = (e) => {
        const updatedSensors = [...activeSensors];

        updatedSensors[sensorIndex].unit = '';
        updatedSensors[sensorIndex].statusSensor = '';
        updatedSensors[sensorIndex].energyValue = '';
        updatedSensors[sensorIndex].powerUnit = '';
        updatedSensors[sensorIndex].powerValue = '';
        updatedSensors[sensorIndex].efficiency = '';
        updatedSensors[sensorIndex].load = '';
        updatedSensors[sensorIndex].volts = '';
        updatedSensors[sensorIndex].powerFactor = '';
        updatedSensors[sensorIndex].phase = 'singlePhase';

        updatedSensors[sensorIndex].energyValue = e.value;

        setSensors(updatedSensors);
    };

    const handleChangeSensor = (event, name) => {
        const updatedSensors = [...activeSensors];

        if (name === 'unit') {
            updatedSensors[sensorIndex].powerUnit = event.target.value.name;
            updatedSensors[sensorIndex][name] = event.target.value;
        } else {
            updatedSensors[sensorIndex][name] = event.target.value;
        }

        setSensors(updatedSensors);
    };

    const handlePhaseChange = e => {
        const updatedSensors = [...activeSensors];

        updatedSensors[sensorIndex].phase = e.value;

        setSensors(updatedSensors);
    };

    const removeSensor = () => {
        const updatedSensors = [...activeSensors];

        updatedSensors.splice(sensorIndex, 1);

        setSensors(updatedSensors);
    };

    const renderStatusValuePanel = () => {
        return (
            <React.Fragment>
                <div>
                    <span className={classes.InputContainer}>
                        <BobSelectField
                            id={'statusSensor'}
                            name={'statusSensor'}
                            value={activeSensors[sensorIndex].statusSensor}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].statusSensor)}
                            touched={formik.touched.statusSensor}
                            options={statusSensors}
                            textField="name"
                            dataItemKey="id"
                            label={'Status Sensor'}
                            size={'medium'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                    <span className={classes.InputContainer}>
                        <BobNumericInputField
                            id={'powerValue'}
                            name={'powerValue'}
                            value={activeSensors[sensorIndex].powerValue}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && activeSensors[sensorIndex].powerValue === ''}
                            touched={formik.touched.powerValue}
                            label={'Value'}
                            size={'small'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                    <span className={classes.InputContainer}>
                        <BobSelectField
                            id={'unit'}
                            name={'unit'}
                            options={options}
                            onChange={handleChangeSensor}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].unit)}
                            touched={formik.touched.unit}
                            size={'medium'}
                            fillMode={'outline'}
                            rounded={'medium'}
                            label={'Unit'}
                            textField="name"
                            dataItemKey="id"
                            value={activeSensors[sensorIndex].unit}
                        />
                    </span>
                </div>
            </React.Fragment>
        );
    };

    const renderEnergyValuePanel = () => {
        return (
            <React.Fragment>
                <div>
                    <span className={classes.InputContainer}>
                        <BobSelectField
                            id={'statusSensor'}
                            name={'statusSensor'}
                            value={activeSensors[sensorIndex].statusSensor}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].statusSensor)}
                            touched={formik.touched.statusSensor}
                            options={energySensors}
                            textField="name"
                            dataItemKey="id"
                            label={'Status Sensor'}
                            size={'medium'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                    <span className={classes.InputContainer}>
                        <BobSelectField
                            id={'unit'}
                            name={'unit'}
                            options={options}
                            onChange={handleChangeSensor}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].unit)}
                            touched={formik.touched.unit}
                            size={'medium'}
                            fillMode={'outline'}
                            label={'Unit'}
                            rounded={'medium'}
                            textField="name"
                            dataItemKey="id"
                            value={activeSensors[sensorIndex].unit}
                        />
                    </span>
                </div>
            </React.Fragment>
        );
    };

    const renderWattsPanel = () => {
        return (
            <React.Fragment>
                <div>
                    <span className={classes.InputContainer}>
                        <BobInputField
                            id={'efficiency'}
                            name={'efficiency'}
                            value={activeSensors[sensorIndex].efficiency}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].efficiency)}
                            touched={formik.touched.efficiency}
                            label={'Efficiency'}
                            size={'small'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                    <span className={classes.InputContainer}>
                        <BobInputField
                            id={'load'}
                            name={'load'}
                            value={activeSensors[sensorIndex].load}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].load)}
                            touched={formik.touched.load}
                            label={'Load'}
                            size={'small'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                </div>
            </React.Fragment>
        );
    };

    const renderAmpsPanel = () => {
        return (
            <React.Fragment>
                <div>
                    <span className={classes.InputContainer}>
                        <BobNumericInputField
                            id={'volts'}
                            name={'volts'}
                            value={activeSensors[sensorIndex].volts}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && activeSensors[sensorIndex].volts === ''}
                            touched={formik.touched.volts}
                            label={'Volts'}
                            size={'small'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                </div>
                <div>
                    <span className={classes.InputContainer}>
                        <BobNumericInputField
                            id={'powerFactor'}
                            name={'powerFactor'}
                            value={activeSensors[sensorIndex].powerFactor}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && activeSensors[sensorIndex].powerFactor === ''}
                            touched={formik.touched.powerFactor}
                            label={'Power Factor'}
                            size={'small'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                    <span className={classes.InputContainer}>
                        <BobInputField
                            id={'efficiency'}
                            name={'efficiency'}
                            value={activeSensors[sensorIndex].efficiency}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].efficiency)}
                            touched={formik.touched.efficiency}
                            label={'Efficiency'}
                            size={'small'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                    <span className={classes.InputContainer}>
                        <BobInputField
                            id={'load'}
                            name={'load'}
                            value={activeSensors[sensorIndex].load}
                            onChange={handleChangeSensor}
                            onBlur={handleBlurValue}
                            errors={hasValidated && isEmpty(activeSensors[sensorIndex].load)}
                            touched={formik.touched.load}
                            label={'Load'}
                            size={'small'}
                            fillMode={'outline'}
                            rounded={'medium'}
                        />
                    </span>
                </div>
                <div className={classes.RadioButtonContainer}>
                    <BobRadioGroup
                        id={'phase'}
                        name={'phase'}
                        color={'black'}
                        data={phaseValues}
                        layout={'horizontal'}
                        onChange={handlePhaseChange}
                        value={activeSensors[sensorIndex].phase}
                    />
                </div>
            </React.Fragment>
        );
    };

    return (
        <div className={classes.UpperPanel}>
            <div className={classes.Title}>
                Energy Consumption Details
                <span onClick={() => removeSensor()} role="none" className={clsx('material-symbols-outlined', classes.DeleteIcon)}>
                    delete
                </span>
            </div>
            <div>
                <BobRadioGroup
                    color={'black'}
                    data={energyValues}
                    layout={'horizontal'}
                    onChange={handleChange}
                    value={activeSensors[sensorIndex].energyValue}
                />
            </div>
            {
                activeSensors[sensorIndex].energyValue === 'statusValue' ?
                    renderStatusValuePanel()
                    :
                    activeSensors[sensorIndex].energyValue === 'energyValue' ?
                        renderEnergyValuePanel()
                        :
                        null
            }
            {
                (activeSensors[sensorIndex].powerUnit === 'Watts' ||
                    activeSensors[sensorIndex].powerUnit === 'Kilowatts' ||
                    activeSensors[sensorIndex].powerUnit === 'Horsepower')
                    && activeSensors[sensorIndex].energyValue ?
                    renderWattsPanel()
                    :
                    activeSensors[sensorIndex].powerUnit === 'Amps' && activeSensors[sensorIndex].energyValue ?
                        renderAmpsPanel()
                        :
                        null
            }
        </div>
    );
};

export default EquipmentEnergyMonitorPanel;
